
import { useParams, useNavigate } from "react-router-dom";
import { WorkoutHeader } from "./components/WorkoutHeader";
import { WorkoutPreview } from "./components/WorkoutPreview";
import { WorkoutContainer } from "./components/WorkoutContainer";
import { WorkoutShimmer } from "./components/WorkoutShimmer";
import { ResumeWorkoutDialog } from "./components/ResumeWorkoutDialog";
import { useWorkout } from "./hooks/useWorkout";
import { Exercise } from "./types";

export const WorkoutView = () => {
  const { routineId } = useParams();
  const navigate = useNavigate();
  const {
    routine,
    isLoading,
    workoutStarted,
    activeExerciseId,
    currentSetIndex,
    completedSets,
    showCompletionCheck,
    showTimer,
    isExerciseRest,
    showResumeDialog,
    sessionAge,
    handleStartWorkout,
    handleSetComplete,
    handleTimerComplete,
    handleTimerSkip,
    getActiveExercise,
    handleExerciseSelect,
    handleStopWorkout,
    handleResumeWorkout,
    handleStartFresh
  } = useWorkout(routineId);

  console.log('🏋️ WorkoutView - Current workout state with enhanced data:', {
    routineId,
    workoutStarted,
    activeExerciseId,
    completedSets,
    exercisesCount: routine?.exercises?.length || 0,
    hasEnhancedData: routine?.exercises?.some(ex => ex.set_data?.length > 0)
  });

  const handleBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    handleStartFresh();
    navigate('/');
  };

  if (isLoading) {
    return <WorkoutShimmer />;
  }

  if (!routine) {
    return (
      <div className="min-h-screen bg-background text-foreground flex items-center justify-center">
        <div className="text-center text-muted-foreground">Rutina no encontrada</div>
      </div>
    );
  }

  const exercises = routine.exercises as Exercise[];

  console.log('🎯 WorkoutView - Exercises with enhanced set data:', 
    exercises?.map(ex => ({
      id: ex.id,
      name: ex.name,
      sets: ex.sets,
      setDataLength: ex.set_data?.length || 0,
      firstSetData: ex.set_data?.[0]
    }))
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-background via-background to-background/95 dark:from-black dark:via-gray-950 dark:to-gray-900 ocean:from-[#081F2B] ocean:via-[#0a2836] ocean:to-[#0d3040] sunset:from-[#2B1408] sunset:via-[#1f0f06] sunset:to-[#150a04] forest:from-[#122112] forest:via-[#0d1a0d] forest:to-[#081208] text-foreground transition-colors duration-500">
      {/* Resume Dialog */}
      <ResumeWorkoutDialog
        isOpen={showResumeDialog}
        sessionAge={sessionAge}
        onResume={handleResumeWorkout}
        onStartFresh={handleStartFresh}
        onGoHome={handleGoHome}
      />

      {!workoutStarted ? (
        <>
          <WorkoutHeader onBack={handleBack} />
          <WorkoutPreview
            routine={routine}
            durationInMinutes={Math.ceil((exercises?.reduce((acc, exercise) => 
              acc + (exercise.sets * 45), 0) || 0) / 60)}
            exerciseCount={exercises?.length || 0}
            onStartWorkout={handleStartWorkout}
          />
        </>
      ) : activeExerciseId && getActiveExercise() && (
        <WorkoutContainer
          exercise={getActiveExercise()!}
          currentSetIndex={currentSetIndex}
          completedSets={completedSets}
          showCompletionCheck={showCompletionCheck}
          showTimer={showTimer}
          isExerciseRest={isExerciseRest}
          onSetComplete={handleSetComplete}
          onTimerComplete={handleTimerComplete}
          onTimerSkip={handleTimerSkip}
          allExercises={exercises || []}
          onExerciseSelect={handleExerciseSelect}
          onBack={handleStopWorkout}
        />
      )}
    </div>
  );
};
